import styles from './styles.module.css';

type Props = {
  label: string;
  name: string;
  value: string;
  startIcon?: boolean;
  endIcon?: boolean;
  disabled?: boolean;
  isChecked?: boolean;
  size?: 'medium' | 'large';
  onClick?: () => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const ChipsRadio = ({
  label,
  name,
  value,
  startIcon,
  endIcon,
  disabled,
  isChecked,
  size = 'medium',
  onClick,
  onChange,
}: Props) => {
  const chipsIsDisabled = disabled ? styles.boxChipsradioLabelDisabled : '';
  const sizeClass = size ? styles[size] : '';
  const contentSizeClass =
    size === 'large' ? styles.boxChipsradioLabelContentLarge : styles.boxChipsradioLabelContentMedium;

  return (
    <button
      className={styles.chipsradioContainer}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          if (onClick) onClick();
        }
      }}
    >
      <label className={`${styles.boxChipsradioLabel} ${sizeClass} ${chipsIsDisabled}`}>
        <input
          type="radio"
          className={styles.boxChipsradioLabelInput}
          name={name}
          value={value}
          defaultChecked={isChecked}
          onChange={onChange}
        />
        <span className={styles.boxChipsradioLabelSpan}></span>

        {startIcon && (
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.chipsradioStarticon}
          >
            <path d="M16 13C15.4092 13.0039 14.8266 13.1386 14.294 13.3945C13.7615 13.6504 13.2922 14.0211 12.92 14.48L7.82003 12.13C8.05982 11.3957 8.05982 10.6042 7.82003 9.86999L12.92 7.51999C13.5216 8.24596 14.3604 8.73607 15.2882 8.90383C16.216 9.07159 17.1732 8.90622 17.991 8.4369C18.8087 7.96757 19.4344 7.22447 19.7576 6.33874C20.0808 5.453 20.0807 4.48157 19.7573 3.5959C19.434 2.71022 18.8082 1.96724 17.9903 1.49806C17.1725 1.02889 16.2152 0.863686 15.2875 1.03162C14.3597 1.19955 13.521 1.68981 12.9196 2.41589C12.3181 3.14196 11.9924 4.05717 12 4.99999C12.003 5.23822 12.0265 5.47576 12.07 5.70999L6.79003 8.13999C6.22711 7.58957 5.51427 7.21751 4.74083 7.07042C3.96739 6.92333 3.16775 7.00776 2.44208 7.31312C1.71641 7.61849 1.09699 8.13121 0.661428 8.78705C0.225866 9.4429 -0.00646973 10.2127 -0.00646973 11C-0.00646973 11.7873 0.225866 12.5571 0.661428 13.2129C1.09699 13.8688 1.71641 14.3815 2.44208 14.6869C3.16775 14.9922 3.96739 15.0767 4.74083 14.9296C5.51427 14.7825 6.22711 14.4104 6.79003 13.86L12.07 16.29C12.0265 16.5242 12.003 16.7618 12 17C12 17.7911 12.2346 18.5645 12.6742 19.2223C13.1137 19.8801 13.7384 20.3928 14.4693 20.6955C15.2002 20.9983 16.0045 21.0775 16.7804 20.9231C17.5563 20.7688 18.269 20.3878 18.8285 19.8284C19.3879 19.269 19.7688 18.5563 19.9232 17.7804C20.0775 17.0044 19.9983 16.2002 19.6955 15.4693C19.3928 14.7384 18.8801 14.1136 18.2223 13.6741C17.5645 13.2346 16.7912 13 16 13ZM16 2.99999C16.3956 2.99999 16.7823 3.11729 17.1112 3.33705C17.4401 3.55682 17.6964 3.86917 17.8478 4.23463C17.9992 4.60008 18.0388 5.00221 17.9616 5.39017C17.8844 5.77813 17.6939 6.1345 17.4142 6.41421C17.1345 6.69391 16.7782 6.88439 16.3902 6.96156C16.0022 7.03873 15.6001 6.99913 15.2347 6.84775C14.8692 6.69638 14.5569 6.44003 14.3371 6.11113C14.1173 5.78223 14 5.39556 14 4.99999C14 4.46956 14.2107 3.96085 14.5858 3.58578C14.9609 3.21071 15.4696 2.99999 16 2.99999ZM4.00003 13C3.60447 13 3.21779 12.8827 2.88889 12.6629C2.55999 12.4432 2.30364 12.1308 2.15227 11.7654C2.00089 11.3999 1.96129 10.9978 2.03846 10.6098C2.11563 10.2218 2.30611 9.86548 2.58581 9.58578C2.86552 9.30607 3.22189 9.11559 3.60985 9.03842C3.99781 8.96125 4.39994 9.00086 4.7654 9.15223C5.13085 9.30361 5.4432 9.55995 5.66297 9.88885C5.88273 10.2178 6.00003 10.6044 6.00003 11C6.00003 11.5304 5.78931 12.0391 5.41424 12.4142C5.03917 12.7893 4.53046 13 4.00003 13ZM16 19C15.6045 19 15.2178 18.8827 14.8889 18.6629C14.56 18.4432 14.3036 18.1308 14.1523 17.7654C14.0009 17.3999 13.9613 16.9978 14.0385 16.6098C14.1156 16.2218 14.3061 15.8655 14.5858 15.5858C14.8655 15.3061 15.2219 15.1156 15.6098 15.0384C15.9978 14.9613 16.3999 15.0009 16.7654 15.1522C17.1308 15.3036 17.4432 15.56 17.663 15.8889C17.8827 16.2177 18 16.6044 18 17C18 17.5304 17.7893 18.0391 17.4142 18.4142C17.0392 18.7893 16.5305 19 16 19Z" />
          </svg>
        )}

        <span className={`${styles.boxChipsradioLabelContent} ${contentSizeClass}`}>{label}</span>

        {endIcon && (
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.chipsradioEndicon}
          >
            <path d="M7.40994 5.99994L11.7099 1.70994C11.8982 1.52164 12.004 1.26624 12.004 0.999941C12.004 0.73364 11.8982 0.478245 11.7099 0.289941C11.5216 0.101638 11.2662 -0.00415039 10.9999 -0.00415039C10.7336 -0.00415039 10.4782 0.101638 10.2899 0.289941L5.99994 4.58994L1.70994 0.289941C1.52164 0.101638 1.26624 -0.00415039 0.999939 -0.00415039C0.733637 -0.00415039 0.478243 0.101638 0.289939 0.289941C0.101635 0.478245 -0.00415277 0.73364 -0.00415277 0.999941C-0.00415278 1.26624 0.101635 1.52164 0.289939 1.70994L4.58994 5.99994L0.289939 10.2899C0.196211 10.3829 0.121816 10.4935 0.0710478 10.6154C0.0202791 10.7372 -0.00585938 10.8679 -0.00585938 10.9999C-0.00585938 11.132 0.0202791 11.2627 0.0710478 11.3845C0.121816 11.5064 0.196211 11.617 0.289939 11.7099C0.382902 11.8037 0.493503 11.8781 0.615362 11.9288C0.737221 11.9796 0.867927 12.0057 0.999939 12.0057C1.13195 12.0057 1.26266 11.9796 1.38452 11.9288C1.50638 11.8781 1.61698 11.8037 1.70994 11.7099L5.99994 7.40994L10.2899 11.7099C10.3829 11.8037 10.4935 11.8781 10.6154 11.9288C10.7372 11.9796 10.8679 12.0057 10.9999 12.0057C11.132 12.0057 11.2627 11.9796 11.3845 11.9288C11.5064 11.8781 11.617 11.8037 11.7099 11.7099C11.8037 11.617 11.8781 11.5064 11.9288 11.3845C11.9796 11.2627 12.0057 11.132 12.0057 10.9999C12.0057 10.8679 11.9796 10.7372 11.9288 10.6154C11.8781 10.4935 11.8037 10.3829 11.7099 10.2899L7.40994 5.99994Z" />
          </svg>
        )}
      </label>
    </button>
  );
};

export default ChipsRadio;
